"use client";

import { Flex, Text } from "@radix-ui/themes";
import React from "react";
import { Role } from "@prisma/client";
import FooterItem from "./FooterItem";
import Link from "next/link";
import { ArrowTopRightIcon } from "@radix-ui/react-icons";
import Container from "./Container";
import { usePathname } from "next/navigation";
import { ExtendedSession } from "@/lib/interface/ExtendedSession";
import { useDynamicConfig } from "@statsig/react-bindings";
import { TenantInfoKey } from "@/lib/enum/statsig/tenantInfoKey";
import FooterLogo from "./FooterLogo";

const EXCLUDE_FOOTERS_REGEXES = [
  "/auth/signin",
  "/auctions/\\d+/portal",
  "/verify",
  "/email/verify/send",
  "/password",
  "/account",
  "/watchlist",
];

const Footer = ({ session }: { session: ExtendedSession | null }) => {
  const config = useDynamicConfig("tenant_info");
  const pathname = usePathname();

  // Check if we're on a not-found page by checking if the current route matches any known routes
  const isNotFound = pathname === '/404' || pathname === '/not-found';

  if (isNotFound || EXCLUDE_FOOTERS_REGEXES.some((r) => new RegExp(r).test(pathname))) {
    return null;
  }

  if (session && session.role == Role.ADMIN) return null;

  const socialMedia = [
    {
      key: TenantInfoKey.TenantInstagram,
      name: "Instagram",
    },
    {
      key: TenantInfoKey.TenantFacebook,
      name: "Facebook",
    },
  ];

  const socialLinks = socialMedia
    .map((social) => ({
      ...social,
      url: config.get(social.key) as string,
    }))
    .filter((social) => social.url);

  return (
    <Container className="flex w-full flex-grow-0">
      <Flex direction={"column"} align={"center"} className="mt-8 w-[90%] mb-8 lg:mb-0">
        <Flex className="h-0.5 p-0 w-full bg-[#EDE9FE]" />
        <Flex className="w-full" justify={"center"}>
          <Flex
            justify={"between"}
            className="w-full lg:px-20 px-5 flex-col gap-4 items-center lg:flex-row lg:items-start"
          >
            <FooterItem
              header="logo"
              content={
                <FooterLogo tenantId={config.get(TenantInfoKey.TenantId) as string} />
              }
            />
            <FooterItem
              header={`Contact ${config.get(TenantInfoKey.TenantName) as string}`}
              content={[
                { start: config.get(TenantInfoKey.TenantAddress) as string },
                { start: config.get(TenantInfoKey.TenantSupportPhone) as string },
                { start: config.get(TenantInfoKey.TenantSupportEmail) as string },
              ]}
            />
            <FooterItem
              header="Contact Biddify"
              content={
                <Flex
                  direction="column"
                  className="text-center lg:text-start"
                >
                  <Text className="text-sm">Auction Platform Support</Text>
                  <Text className="text-sm">(647) 375-8281</Text>
                  <Link
                    href={`mailto:andrew@biddify.io`}
                    className="flex flex-row items-center justify-center lg:justify-start gap-1"
                  >
                    <Text className="text-sm">andrew@biddify.io</Text>
                  </Link>
                </Flex>
              }
            />
            {/* <FooterItem
              header="Social Media"
              content={
                <Flex direction="column" className="gap-1">
                  {socialLinks.map((social) => (
                    <Link
                      href={social.url}
                      key={social.key}
                      className="flex flex-row items-center gap-1"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Text className="text-sm">{social.name}</Text>
                      <ArrowTopRightIcon />
                    </Link>
                  ))}
                </Flex>
              }
            /> */}
          </Flex>
        </Flex>
      </Flex>
    </Container>
  );
};

export default Footer;

export const revalidate = 0;
